var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoggedIn)?_c('img',{attrs:{"src":_vm.imgSrc}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }